import styled from '@emotion/styled';
import FormControlLabel from '@material-ui/core/FormControlLabel';

import theme from '../../themes/default';

export const LabelWrapper = styled('div')`
  padding-left: 12px;
`;

export const Wrapper = styled(FormControlLabel)`
  margin: 0;
  cursor: pointer;

  span {
    color: ${(props) =>
      props.disabled
        ? theme.color.designSystem.blackOpacity38
        : theme.color.designSystem.blackOpacity87};
    font-family: ${theme.font.family.workSans};
    font-weight: ${theme.font.weight.regular};
    font-size: ${theme.font.size.copy};
    line-height: ${theme.font.lineHeight.copy};
    white-space: pre-wrap;
    padding: 0;
  }

  span svg {
    color: ${(props) =>
      props.disabled
        ? theme.color.blackAlpha(0.38)
        : theme.color.blackAlpha(0.6)};
  }

  span.selected svg {
    color: ${(props) =>
      props.disabled
        ? theme.color.designSystem.purple30
        : theme.color.designSystem.purple70};
  }
`;

export default Wrapper;
